import { isKeyOf } from '@issuemanager/apps/client/utils';
import { IssueSeverityEnum } from '@issuemanager/constants';
import { useTranslation } from 'react-i18next';

type UseSeverityLocalizerReturnType = {
  getSeverityLabel: (value: string | undefined) => string | undefined;
};

export function useSeverityLocalizer(): UseSeverityLocalizerReturnType {
  const { t } = useTranslation('common');

  const severityMap: Record<IssueSeverityEnum, string> = {
    [IssueSeverityEnum.LOW]: t('severity.low'),
    [IssueSeverityEnum.MEDIUM]: t('severity.medium'),
    [IssueSeverityEnum.HIGH]: t('severity.high'),
    [IssueSeverityEnum.CRITICAL]: t('severity.critical'),
  };

  return {
    getSeverityLabel: (value: string | undefined): string | undefined => {
      if (!value) return undefined;
      return isKeyOf(value, severityMap) ? severityMap[value] : value;
    },
  };
}
